/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable no-console */
import React, { Component } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import {
    Grid,
    Row,
    Column,
    Keyboard,
    Button,
    Heading,
    Form,
    FormInput,
    cls,
    HeaderCompound
} from 'packages/components';
import { connect } from 'react-redux';
import Translator from '../../requests/apa/Translator';
import { autobind } from 'packages/core/lib';
import { PAYMENT_FACTURA_FIJA } from '../utils/constants';
import { showModal, AAF_MODAL_SUCCESS_SUSCRIPTION } from '../../actions/modal';
import { apiPaywayConfirm, onPaymetSuccess, showError, getWorkflow, getNumberLength, setInitialFocus, onFocusMultipleElements, handleTypeModal, redirectPlayerOneClic, isModalHide } from '../utils/Utils';
import UtilsPagos from "../../utils/payway/UtilsPagos";
import Device from '../../devices/device';
import Assets from '../../requests/apa/Asset';
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import Spinner from '../../components/Spinner';
import './_styles.scss';
import { setMetricsEvent } from '../../actions/metrics';
import Utils, { enablePaymentMethodExperience } from 'src/utils/Utils';
import { COMPONENT_PLAN_SELECTOR, METODO_DE_PAGO, LABER_AGREGAR_MEDIO_DE_PAGO, LABER_CANCELAR_MEDIO_DE_PAGO_SELECCIONADO } from '../../packages/components/lib/utils/constants';


interface IHubFacturaFija {
    form: {
        cuentaservicio: string;
        claveservicio: string;
    };
    errorFromBackend: string;
    valid: boolean;
    showTooltipSuccess: boolean;
    pbi: any;
    worflowstart: any;
    selectedPaymentMethod: string;
    type: number;
    isLoading: boolean;
    document: string;
    activeElement: string;
    element: any;
}

class HubFacturaFijaGate extends Component<RouteComponentProps, IHubFacturaFija> {
    public textNext: string = Translator.get('hubfacturafijagate_access_option_button_next', 'SIGUIENTE');
    public textCancel: string = Translator.get(
        'hubfacturafijagate_access_option_button_cancel',
        'CANCELAR'
    );

    private isValidForm: boolean;
    public keys = (Device.getDevice() && Device.getDevice().getKeys()) || null;
    private from: string = '';

    constructor(props: RouteComponentProps) {
        super(props);
        const { location: { state = {} } = {} } = props || {};
        this.from = state?.from;
        this.state = {
            form: {
                cuentaservicio: '',
                claveservicio: '',
            },
            errorFromBackend: '',
            valid: false,
            showTooltipSuccess: false,
            pbi: {},
            worflowstart: {},
            selectedPaymentMethod: '',
            type: 0,
            isLoading: false,
            document: '',
            activeElement: '',
            element: ''
        };
    }

    public componentDidMount(): void {
        document && document.removeEventListener('keydown', this.onKeyPress, true);
        document && document.addEventListener('keydown', this.onKeyPress, true);
        document && document.addEventListener('sn:enter-up', this.enterUpHandler, true);
        const selectedPaymentMethod = this.props.location.state.method;
        const {
            location: {
                state: { type = null, pbi = false, worflowstart = false } = {},
            } = {},
        } = this.props;
        if (pbi && worflowstart && type) {
            this.setState({ pbi, worflowstart, selectedPaymentMethod, type });
        }
        if (isModalHide()) {
            setInitialFocus('.aaf_form-group-input-element .aaf_focusable', false);
        }
    }

    public componentWillUnmount(): void {
        document && document.removeEventListener('keydown', this.onKeyPress, true);
        document && document.removeEventListener('sn:enter-up', this.enterUpHandler, true);
    }

    public componentDidUpdate(): void {
        this.onFocus();
    }

    public enterUpHandler = (e: any) => {
        const el: any = e.target;
        if (el.className.includes('aaf_focusable')) {
            this.setState({ element: e.target });
        }
    };

    @autobind
    private handleChange(value: string, type: string, obj: any): void {
        let { form } = this.state;
        const { $form: { activeField } } = obj['context'];
        this.isValidForm = value !== '';
        this.setState({ activeElement: activeField, form: { ...form, [type]: value } } as IHubFacturaFija);
    }

    private handleSubmit = (): void => {
        const {
            worflowstart,
            form: { claveservicio, cuentaservicio },
            pbi,
            pbi: { isSubscription },
            selectedPaymentMethod,
        } = this.state;
        const wfs = getWorkflow(selectedPaymentMethod, worflowstart);
        let cb = isSubscription ? (resp: object) => this.redirectAddon(resp) : (resp: any) => this.redirectVCard(resp);
        if (claveservicio && cuentaservicio) {
            apiPaywayConfirm({
                pbi,
                wfs,
                formParams: { cuentaServicio: cuentaservicio, claveServicio: claveservicio },
            })
                .then((resp) => {
                    onPaymetSuccess(resp, pbi, wfs, selectedPaymentMethod, cb);
                })
                .catch((err) => {
                    showError(err);
                    this.setState({ isLoading: false });
                });
        }
    };

    @autobind
    private showTicket(resp: any, groupId: string, islive: boolean) {
        const { showModal } = this.props;
        const { type, worflowstart: { contentInfo }, pbi, pbi: { producttype, currency, price, family, periodicity, frequency }, selectedPaymentMethod } = this.state;
        const region = DeviceStorage.getItem('region');
        const { response: { paymentMethodData: { account = '' } = {}, end_date: { day = '', month = '', year = '' } = {}, payway_token = '' } = {} } = resp || {};
        const payDate = `${day} ${month} ${year}`;
        const paymentMethodLabel = account ? `${Translator.get(`ticket_subscription_${selectedPaymentMethod}_label`, '')} ${account}` : Translator.get(`ticket_subscription_${selectedPaymentMethod}_label`, '')

        const data = {
            pbi,
            total: UtilsPagos.getTotalAndPeriodicity(currency, price, periodicity),
            duration: `${Translator.get(periodicity, '')}`,
            frequency: frequency,
            days: Translator.get(`bonus_${producttype}`),
            content: Translator.get(`Ticket_Transaccion_TextoDescripcion_${producttype}`, ''),
            payment_method: paymentMethodLabel,
            img_largeSub: Assets.get(`${region}_transactional_${family}_poster`, ''),
            img_large: contentInfo?.contentImageMedium,
            providerImage: Assets.get(`transactional_${family}_logo`),
            title: contentInfo?.contentTitle || '',
            type: type,
            from: this.from
        };

        const modal = {
            modalType: AAF_MODAL_SUCCESS_SUSCRIPTION,
            modalProps: {
                data: handleTypeModal({ ...data, next_pay: payDate }),
                handlePlay: () => this.from ? this.handleAddOn(resp) : this.handlePlay(groupId, payway_token, islive),
                handleVCard: () => this.handleVCard(groupId),
                payment_methods_experience: enablePaymentMethodExperience()
            }
        };
        showModal(modal);
    }

    private redirectAddon(resp: any): void {
        const { pbi: { groupId = '', oneoffertype = '', islive = false }, worflowstart: { selectedPaymentMethod } } = this.state;
        const isOneClicFlow = groupId === '' ? false : true;
        const oneClicKey = `${oneoffertype}_${selectedPaymentMethod}`;
        if (UtilsPagos.oneClicBuyHiddeConfirm(isOneClicFlow, oneClicKey)) {
            if (UtilsPagos.oneClicBuyRedirectPlayer(isOneClicFlow, oneClicKey)) {
                const { response: { payway_token = '' } = {} } = resp || {};
                this.handlePlay(groupId, payway_token, islive);
            }
            else {
                // este caso aplica cuando no se tiene activado el one clic muestra modal de compra exitosa
                this.showTicket(resp, groupId, islive);
            }
        } else {
            // aplica para plan selector y vcard cuando no hay one clic
            this.showTicket(resp, groupId, islive);
        }
    }

    private redirectVCard(resp?: any): void {
        const { pbi: { groupId = '', oneoffertype = '', islive = false }, worflowstart: { selectedPaymentMethod } } = this.state;
        const isOneClicFlow = groupId === '' ? false : true;
        const oneClicKey = `${oneoffertype}_${selectedPaymentMethod}`;
        if (UtilsPagos.oneClicBuyHiddeConfirm(isOneClicFlow, oneClicKey)) {
            if (UtilsPagos.oneClicBuyRedirectPlayer(isOneClicFlow, oneClicKey)) {
                setTimeout(() => {
                    const { history } = this.props;
                    const nav = Utils.getApaMetadataKey('links_nav_configuration', Utils.mock_links_nav_configuration());
                    if (islive) {
                        if(nav && nav.home) {
                            history.replace(`/node/${nav.home}`);
                        }
                    }
                    else if (groupId) {
                        this.handleVCard(groupId);
                    }
                }, 0);
            }
            else {
                // este caso aplica cuando no se tiene activado el one clic muestra modal de compra exitosa
                this.showTicket(resp, groupId, islive);
            }
        } else {
            // aplica para plan selector y vcard cuando no hay one clic
            this.showTicket(resp, groupId, islive);
        }
    }

    private handleAddOn(resp: any) {
        const { history, nodes } = this.props;
        const { response: { node_id = '' } = {} } = resp || {};
        let nodeString: string = '';
        const filterNodes = nodes.filter((value: any) => value.code === 'playandgo');
        const resultChilds = filterNodes.map((res: any) => {
            const childsValue = res.childs;
            return childsValue;
        });

        for (let index = 0; index < resultChilds.length; index++) {
            const element = resultChilds[index];
            element.map((resId: any) => {
                if (resId.id === node_id) {
                    return nodeString = resId.code;
                }
            });
        }

        this.setState({ isLoading: false });
        history.replace(`/node/${nodeString ? nodeString : 'homeuser'}`);
    }

    @autobind
    private handlePlay(groupId: string, payway_token: string, islive: boolean) {
        if (groupId) {
            redirectPlayerOneClic(groupId, islive, payway_token, () => {
                this.handleVCard(groupId);
            })
        }
    }

    @autobind
    private handleVCard(groupId: string) {
        if (groupId) {
            const { history } = this.props;
            history.replace(`/vcard/${groupId}`);
        }
    }

    private hadleCancel = (): void => {
        const { history } = this.props;
        Utils.sendMetric(this.props, COMPONENT_PLAN_SELECTOR, METODO_DE_PAGO, LABER_CANCELAR_MEDIO_DE_PAGO_SELECCIONADO);
        history.goBack();
    };

    @autobind
    private handleBack(): void {
        const { history } = this.props;
        history.goBack();
    }

    @autobind
    private onKeyPress(e: any): void {
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
        if (currentKey === 'YELLOW') {
            this.handleBack();
        }
    }

    @autobind
    private onFocus(): void {
        const { element } = this.state;
        let activeCuenta: boolean = false;
        let activeClave: boolean = false;
        const numberElments = document.getElementsByClassName('aaf_focusable');
        if (numberElments.length > 1) {
            activeCuenta = true;
            if (element.id === 'claveservicio') {
                activeCuenta = false;
                activeClave = true;
            }
        }

        onFocusMultipleElements([{ id: 'cuentaservicio', activeElement: activeCuenta }, { id: 'claveservicio', activeElement: activeClave }]);
    }

    public render(): JSX.Element {
        const {
            worflowstart,
            selectedPaymentMethod,
            isLoading
        } = this.state;
        const wfs = getWorkflow(selectedPaymentMethod, worflowstart);
        const { gatewaytext } = wfs;
        if (isLoading) return <Spinner className={cls(`${PAYMENT_FACTURA_FIJA}-spinner`)} loadingMessage='' />;
        return (
            <Grid className={Device.getDevice().getPlatform()}>
                <HeaderCompound
                    disabled
                    align='right'
                    onClick={this.handleBack}
                    textBack={Translator.get('top_head_option_button_back', 'REGRESAR')}
                    icon={`${Assets.get('top_head_option_back')}`}
                    onFocus={this.onFocus}
                />
                <Row>
                    <Column lg={12}>
                        <Heading size={2} className={cls(`${PAYMENT_FACTURA_FIJA}-title`)}>
                            {this.from && this.from === 'plan-selector' ? Translator.get('top_head_step_3_label', 'PASO 3 DE 3') : ''}
                        </Heading>
                    </Column>
                </Row>
                <Row>
                    <Form id="payment-factura-fija-form">
                        <Column lg={6} className={cls(`${PAYMENT_FACTURA_FIJA}-column-keyboard`)}>
                            <Keyboard id="Keyboard" onFocus={this.onFocus} />
                        </Column>
                        <Column lg={6} className={cls(`${PAYMENT_FACTURA_FIJA}-column-inputs`)}>
                            <Row className={cls(`${PAYMENT_FACTURA_FIJA}-row-inputs`)}>
                                <Column lg={12}>
                                    <Heading
                                        size={1}
                                        className={cls(`${PAYMENT_FACTURA_FIJA}-title-form`)}
                                    >
                                        {gatewaytext}
                                    </Heading>
                                </Column>
                                <Row className={cls(`${PAYMENT_FACTURA_FIJA}-column-input`)}>
                                    <Column lg={12} className={`${PAYMENT_FACTURA_FIJA}-bottom`}>
                                        <FormInput
                                            focusWhenMount
                                            id="cuentaservicio"
                                            type="text"
                                            name="cuentaservicio"
                                            placeholder={Translator.get('hubfacturafijagate_idUser_placeHolder_textfield', 'Usuario')}
                                            onChange={(e, obj) => this.handleChange(e, 'cuentaservicio', obj)}
                                            validInput={true}
                                        />
                                    </Column>
                                    <Column lg={12}>
                                        <FormInput
                                            id="claveservicio"
                                            type="mobile"
                                            name="claveservicio"
                                            placeholder={Translator.get('hubfacturafijagate_keyUser_placeHolder_textfield', 'Clave')}
                                            onChange={(e, obj) => this.handleChange(e, 'claveservicio', obj)}
                                            validInput={true}
                                            /*maxLength={getNumberLength()}*/
                                        />
                                    </Column>
                                </Row>
                                <Column lg={12}>
                                    <Button
                                        activate
                                        type="button"
                                        variant="primary"
                                        disabled={!this.isValidForm}
                                        className={cls(
                                            `focusable`,
                                            `${PAYMENT_FACTURA_FIJA}-button-next`
                                        )}
                                        onClick={this.handleSubmit}
                                        block
                                        onFocus={this.onFocus}
                                    >
                                        {this.textNext}
                                    </Button>
                                </Column>
                                <Column
                                    lg={12}
                                    className={cls(`${PAYMENT_FACTURA_FIJA}-column-next`)}
                                >
                                    <Button
                                        activate
                                        type="button"
                                        className={cls(
                                            `focusable`,
                                            `${PAYMENT_FACTURA_FIJA}-button-cancel`
                                        )}
                                        onClick={this.hadleCancel}
                                        block
                                        onFocus={this.onFocus}
                                    >
                                        {this.textCancel}
                                    </Button>
                                </Column>
                            </Row>
                        </Column>
                    </Form>
                </Row>
            </Grid>
        );
    }
}

const mapDispatchToProps = {
    showModal,
    setMetricsEvent
};

export default connect(null, mapDispatchToProps)(HubFacturaFijaGate);



// WEBPACK FOOTER //
// ./src/payments/HubFacturaFijaGate/index.tsx